exports.__esModule = true;
exports.default = undefined;

var _dec, _class; /**
                      * Created by menghao on 2016/4/27.
                  */


var _Sloth = require("../Sloth");

var _Sloth2 = _interopRequireDefault(_Sloth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

require("./tab.scss");
var $ = require("jquery");

var Tab = (_dec = _Sloth2.default.component({
    defaultOptions: {
        current: 0
    }
}), _dec(_class = function () {
    function Tab() {
        _classCallCheck(this, Tab);
    }

    Tab.prototype.onInit = function onInit() {
        var obj = this.dom;
        var options = this.options;
        var current = options.current;

        $(".Tab-item", obj).eq(current).addClass("Tab-item_current");
        $(".Tab-content", obj).eq(current).addClass("Tab-content_current");

        $(".Tab-item", obj).click(function () {
            var num = $(this).siblings().andSelf().index(this);
            $(this).addClass("Tab-item_current").siblings().removeClass("Tab-item_current");

            $(".Tab-content", obj).eq(num).addClass("Tab-content_current").siblings().removeClass("Tab-content_current");
        });
    };

    return Tab;
}()) || _class);

// module.exports = function (obj, options) {
//     var current = $(options.current);
//
//     $(".Tab-item", obj).eq(current).addClass("Tab-item_current");
//     $(".Tab-content", obj).eq(current).addClass("Tab-content_current");
//
//     $(".Tab-item", obj).click(function () {
//         var num = $(this).siblings().andSelf().index(this);
//         $(this).addClass("Tab-item_current")
//             .siblings().removeClass("Tab-item_current");
//
//         $(".Tab-content", obj).eq(num).addClass("Tab-content_current")
//             .siblings().removeClass("Tab-content_current");
//     })
// }
//
// module.exports.moduleDefault = {
//     current : 0
// }

exports.default = Tab;


/*****************
 ** WEBPACK FOOTER
 ** ./~/slothd/dist/Tab/tab.js
 ** module id = 27
 ** module chunks = 0
 **/